module.exports = __webpack_public_path__ + "static/img/waistDrum_wx.ed510de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/waistDrum_wx.png
// module id = XD7L
// module chunks = 26